// extracted by mini-css-extract-plugin
export default {"colorLeniear":"linearColored_colorLeniear__yzqDq","coloredConatiner":"linearColored_coloredConatiner__cR6bJ","coloredText":"linearColored_coloredText__lsA69"};